<div class="w-100">
  <div class="card-container">
    <div class="title mb-2">
      Server Connection Tests
    </div>
    <div class="content mb-3">

    </div>
  </div>
  <div class="content-container">
    <div class="title">
      Server Testing
    </div>
    <div class="content">

      <button class="mwp-button mb-3" (click)="checkServerStatus()">
        Test Connections
      </button>
      <label class="label-alt">
        Angular API Config:
      </label>
      <div>
        {{mwpAPIUrl}}
      </div>

      <div class="col-5 note">
        This is only to test MWP internal linked server connections with Auth Token verification.
      </div>

      <table>
        <thead>
          <tr>
            <th style="width: 3%;">
            </th>
            <th style="width: 15%;">
              Server
            </th>
            <th style="width: 20%;">
              URL
            </th>
            <th style="width: 15%;">
              Status Code
            </th>
            <th>
              Error Message
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="p-2 d-flex justify-content-center">
              @if (!isLoaded) {
                <mwp-svg-icon [SvgMatType]="svgType.RadioButtonChecked" [SvgColor]="svgColor.disable"/>
              }
              @if (isLoaded && serverConnectionModel.identityServerAPIConnected) {
                <mwp-svg-icon [SvgMatType]="svgType.CheckMark" [SvgColor]="svgColor.positive" [SvgColor]="svgColor.positive"/>
              }
              @if (isLoaded && !serverConnectionModel.identityServerAPIConnected) {
                <mwp-svg-icon [SvgMatType]="svgType.FiberManualRecord"  [SvgColor]="svgColor.error"/> 
              }
            </td>
            <td>
              Identity Server
            </td>
            <td>
              {{serverConnectionModel.urL_IdentityServerAPIConfig}}
            </td>
            <td>
              {{serverConnectionModel.identityServerAPIStatusCode}}
            </td>
            <td>
              {{serverConnectionModel.identityServerAPIAPIError}}
            </td>
          </tr>
          <tr>
            <td class="p-2 d-flex justify-content-center">
              @if (!isLoaded) {
                <mwp-svg-icon [SvgMatType]="svgType.RadioButtonChecked" [SvgColor]="svgColor.disable"/>
              }
              @if (isLoaded && serverConnectionModel.aD6APIConnected) {
              <mwp-svg-icon [SvgMatType]="svgType.CheckMark" [SvgColor]="svgColor.positive"/>
              }
              @if (isLoaded && !serverConnectionModel.aD6APIConnected) {
              <mwp-svg-icon [SvgMatType]="svgType.FiberManualRecord"  [SvgColor]="svgColor.error"/>
              }
            </td>
            <td>
              Admin API
            </td>
            <td>
              {{serverConnectionModel.urL_AD6APIConfig}}
            </td>
            <td>
              {{serverConnectionModel.aD6APIStatusCode}}
            </td>
            <td>
              {{serverConnectionModel.aD6APIError}}
            </td>
          </tr>
          <tr>
            <td class="p-2 d-flex justify-content-center">
              @if (!isLoaded) {
                <mwp-svg-icon [SvgMatType]="svgType.RadioButtonChecked" [SvgColor]="svgColor.disable"/>
              }
              @if (isLoaded && serverConnectionModel.vertexAPIConnected) {
              <mwp-svg-icon [SvgMatType]="svgType.CheckMark" [SvgColor]="svgColor.positive"/>
              }
              @if (isLoaded && !serverConnectionModel.vertexAPIConnected) {
              <mwp-svg-icon [SvgMatType]="svgType.FiberManualRecord"  [SvgColor]="svgColor.error"/>
              }
            </td>
            <td>
              Vertex API
            </td>
            <td>
              {{serverConnectionModel.urL_VertexAPIConfig}}
            </td>
            <td>
              {{serverConnectionModel.vertexAPIStatusCode}}
            </td>
            <td>
              {{serverConnectionModel.vertexAPIError}}
            </td>
          </tr>
          <tr>
            <td class="p-2 d-flex justify-content-center">
              @if (!isLoaded) {
                <mwp-svg-icon [SvgMatType]="svgType.RadioButtonChecked" [SvgColor]="svgColor.disable"/>
              }
              @if (isLoaded && serverConnectionModel.usioapiConnected) {
              <mwp-svg-icon [SvgMatType]="svgType.CheckMark" [SvgColor]="svgColor.positive"/>
              }
              @if (isLoaded && !serverConnectionModel.usioapiConnected) {
              <mwp-svg-icon [SvgMatType]="svgType.FiberManualRecord"  [SvgColor]="svgColor.error"/>
              }
            </td>
            <td>
              USIO API
            </td>
            <td>
              {{serverConnectionModel.urL_USIOAPIConfig}}
            </td>
            <td>
              {{serverConnectionModel.usioapiStatusCode}}
            </td>
            <td>
              {{serverConnectionModel.usioapiError}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>